import { object, string } from 'yup';
import { getTranslation } from '../../../../../../../../components/localization/customHooks/Translation';

const l10n = getTranslation();

const schema = object().shape({
  email: string().required(l10n.components.signInForm.REQUIRED_EMAIL).email(l10n.components.signInForm.INVALID_EMAIL),
});

export default schema;
